var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bad932b7daeff89466aa5e05519f6a39d25a5b6a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["tryup-hp@pluspace"]={id:"bad932b7daeff89466aa5e05519f6a39d25a5b6a"};
      